
    <mat-icon *ngIf="index != 0" class="divider">chevron_right</mat-icon>
    <span #breadcrumbContainer class="breadcrumb" [innerHTML]="html"></span>
  